// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__eoiKv","skeletonLoading":"skeleton_skeletonLoading__1GOUU"};